import React, { useState, useRef, useEffect } from 'react';
import ReactCrop, { centerCrop, makeAspectCrop, convertToPixelCrop } from 'react-image-crop';
import { canvasPreview } from './canvasPreview';
import { useDebounceEffect } from './useDebounceEffect';
import 'react-image-crop/dist/ReactCrop.css';
import { Button } from '@mui/material';
import { toast } from 'react-toastify';

function centerAspectCrop(mediaWidth, mediaHeight, aspect) {
  return centerCrop(
    makeAspectCrop(
      {
        unit: '%',
        width: 50,
        height: 50
      },
      aspect,
      mediaWidth,
      mediaHeight,
    ),
    mediaWidth,
    mediaHeight
  );
}

function ImageCropModal(props) {
  const [imgSrc, setImgSrc] = useState('');
  const previewCanvasRef = useRef(null);
  const imgRef = useRef(null);
  const [crop, setCrop] = useState();
  const [completedCrop, setCompletedCrop] = useState();
  const [scale, setScale] = useState(1);
  const [rotate, setRotate] = useState(0);
  const [aspect, setAspect] = useState(1);
  const [imgSrc2, setImgSrc2] = useState('')
  const [loading, setLoading] = useState(false)
  const blobUrlRef = useRef(null);
  const fileInputRef = useRef(null);
  useEffect(() => {
    if (props?.userProfileUrlModal?.length > 0) {
      setImgSrc2(props.userProfileUrlModal)
    }
  }, [props.userProfileUrlModal])

  function onCloseClick() {
    setImgSrc('')
    setImgSrc2('')
    props.disableTheButton(false)
    previewCanvasRef.current = null;
    imgRef.current = null;
    fileInputRef.current = null;
    setCrop()
    setCompletedCrop()

  }
  function onSelectFile(e) {
    if (e.target.files && e.target.files.length > 0) {
      props.setInvalidProfileError();
      setCrop(undefined);
      const reader = new FileReader();
      reader.addEventListener('load', () =>
        setImgSrc(reader.result ? reader.result.toString() : '')
      );
      reader.readAsDataURL(e.target.files[0]);
    }
  }

  function onImageLoad(e) {
    props.disableTheButton(true)

    props.disableTheButton(true);
    setAspect(1); // Always set the aspect ratio to 1:1
    const { width, height } = e.currentTarget;
    setCrop(centerAspectCrop(width, height, 1));
  }

  async function onUploadCroppedImage() {
    const image = imgRef.current;
    const previewCanvas = previewCanvasRef.current;

    if (!image || !previewCanvas || !completedCrop) {
      throw new Error('Crop canvas does not exist');
    }

    // Calculate the scaling factors
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;

    // Create an offscreen canvas and draw the cropped image
    const offscreen = new OffscreenCanvas(
      completedCrop.width * scaleX,
      completedCrop.height * scaleY
    );
    const ctx = offscreen.getContext('2d');

    if (!ctx) {
      throw new Error('No 2d context');
    }

    ctx.drawImage(
      previewCanvas,
      0,
      0,
      previewCanvas.width,
      previewCanvas.height,
      0,
      0,
      offscreen.width,
      offscreen.height
    );

    // Convert the image to a Blob (you can specify the type and quality if needed)
    const blob = await offscreen.convertToBlob({
      type: 'image/png',
    });

    // Now, upload the cropped image to your server
    const formData = new FormData();
    formData.append('croppedImage', blob, 'cropped-image.png');

    try {
      const response = await fetch('your-upload-api-endpoint', {
        method: 'POST',
        body: formData,
      });

      if (response.ok) {
        // Handle a successful upload
        console.log('Image uploaded successfully');
      } else {
        // Handle errors in the response
        console.error('Upload failed');
      }
    } catch (error) {
      // Handle network or other errors
      console.error('Error uploading image:', error);
    }
  }

  async function onGenerateFileFromCrop() {
    setLoading(true)
    const image = imgRef.current;
    const previewCanvas = previewCanvasRef.current;

    if (!image || !previewCanvas || !completedCrop) {
      setLoading(false)
      throw new Error('Crop canvas does not exist');
    }

    // This will size relative to the uploaded image
    // size. If you want to size according to what they
    // are looking at on screen, remove scaleX + scaleY
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;

    const offscreen = new OffscreenCanvas(
      completedCrop.width * scaleX,
      completedCrop.height * scaleY
    );
    const ctx = offscreen.getContext('2d');

    if (!ctx) {
      throw new Error('No 2d context');
    }

    ctx.drawImage(
      previewCanvas,
      0,
      0,
      previewCanvas.width,
      previewCanvas.height,
      0,
      0,
      offscreen.width,
      offscreen.height
    );

    // Convert the image to a Blob (specify the appropriate type)
    const blob = await offscreen.convertToBlob({ type: 'image/png' });

    if (blob) {
      // Create a File object from the Blob (you can specify the file name)
      const file = new File([blob], 'cropped-image.png', { type: 'image/png' });

      // Use the File object as needed
      console.log('File created:', file);
      try {
        props.handleImageUpload(file)
        setLoading(false)
      } catch (e) {
        setLoading(false)
        toast.error('Failed to upload cropped image')
      }
    } else {
      console.error('Blob is null');
      return null;
    }
  }

  useDebounceEffect(
    async () => {
      if (
        completedCrop &&
        completedCrop.width &&
        completedCrop.height &&
        imgRef.current &&
        previewCanvasRef.current
      ) {
        canvasPreview(
          imgRef.current,
          previewCanvasRef.current,
          completedCrop,
          scale,
          rotate
        );
      }
    },
    100,
    [completedCrop, scale, rotate]
  );


  const handleImageClick = () => {
    fileInputRef.current.click();
  };


  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      flexDirection: 'column',
      alignItems: 'center',
      flexWrap: 'wrap',
      gap: '10px',
      objectFit: 'cover',
    }}>
      <div className="Crop-Controls" style={{ display: 'flex', justifyContent: 'center' }}>
        {!imgSrc && !imgSrc2 && !loading && (
          <div className={props.classes.upload_button}>
            <input type="file" id="file-input" accept="image/*" onChange={onSelectFile} />
            <label htmlFor="file-input">Click to upload</label>
          </div>
        )}
        {!imgSrc && imgSrc2 && !loading && (
          <div>
            <input
              type="file"
              onChange={onSelectFile}
              style={{ display: 'none' }}
              ref={fileInputRef}
            />
            <img
              onClick={handleImageClick}
              style={{
                height: '100px',
                width: '100px',
                borderRadius: '50%',
                cursor: 'pointer',
              }}
              src={imgSrc2}
              alt="client uploaded image"
            />
          </div>
        )}
      </div>
      {imgSrc && (
        <div style={{ width: '400px' }}>
          <ReactCrop
            crop={crop}
            onChange={(_, percentCrop) => setCrop(percentCrop)}
            onComplete={(c) => setCompletedCrop(c)}
          >
            <img
              ref={imgRef}
              alt="Crop me"
              src={imgSrc}
              style={{
                transform: `scale(${scale}) rotate(${rotate}deg)`,
                width: '100%',
                objectFit: 'cover'
              }}
              onLoad={onImageLoad}
            />
          </ReactCrop>
        </div>
      )}
      {completedCrop && (
        <>
          <div style={{ textAlign: 'center' }}>
            <canvas
              ref={previewCanvasRef}
              style={{
                border: '1px solid black',
                objectFit: 'cover',
                width: '100px',
                height: '100px',
                borderRadius: '50%'
              }}
            />
          </div>
          <div>
            <Button color="primary" onClick={onGenerateFileFromCrop}>
              save cropped image
            </Button>
            <Button color="secondary" onClick={onCloseClick}>
              close cropping image
            </Button>
          </div>
        </>
      )}
    </div>
  );
}

export default ImageCropModal;
